import { Decimal } from 'decimal.js';
// import { EntityActions } from '~/apps/shared/actions/consts';
import { BalanceActions } from '../actions/consts';

type BalanceState = {
  balance: Decimal;
  loading: boolean;
  errorMessage: string;
}

export function balance(state = { loading: false, errorMessage: '' } as BalanceState, action) {
  switch (action.type) {
    case BalanceActions.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case BalanceActions.LOAD_SUCCESS:
      return {
        ...state,
        balance: action.balance,
        loading: false,
        errorMessage: '',
      };
    case BalanceActions.LOAD_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.error.errorMessage,
      };
    default:
      return state;
  }
}
